<template>
  <div class="user-earned">
    <div class="user-earned__title">Earned this month</div>
    <div class="user-earned__button">
      <Coins/>
      <span class="user-earned__text">
        <ICountUp :delay="countUp.delay"
                  :endVal="sum"
                  :options="countUp.options"
                  @ready="onReady"/>
        AED
      </span>
    </div>
    <div class="user-earned-balance">
      <div class="user-earned-balance__item">
        <span class="user-earned-balance__title">Fix</span>
        <span>
          AED
          <ICountUp :delay="countUp.delay"
                    :endVal="fixedSalary"
                    :options="countUp.options"
                    @ready="onReadyFix"/>
        </span>
      </div>
      <div class="user-earned-balance__item">
        <span class="user-earned-balance__title">Flex</span>
        <span class="user-earned-balance__flex">
          + AED
          <ICountUp :delay="countUp.delay"
                    :endVal="flexSalary"
                    :options="countUp.options"
                    @ready="onReadyFlex"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Coins from '@/components/Main/Icons/Coins'
import ICountUp from 'vue-countup-v2'
import {get} from 'lodash'
export default {
  name: 'UserEarned',
  props: ['userKpi'],
  computed: {
    flexSalary () {
      return get(this.userKpi, 'bonusToBePaid', 0)
    },
    fixedSalary () {
      return get(this.userKpi, ['position', 'fixedSalary'], 0)
    },
    sum () {
      return this.flexSalary + this.fixedSalary
    }
  },
  components: {
    Coins,
    ICountUp
  },
  data () {
    return {
      countUp: {
        delay: 0,
        options: {
          duration: 0.5,
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          decimalPlaces: 2
        }
      }
    }
  },
  methods: {
    onReady (instance) {
      instance.update(this.sum)
    },
    onReadyFix (instance) {
      instance.update(this.fixedSalary)
    },
    onReadyFlex (instance) {
      instance.update(this.flexSalary)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.user-earned {
  @include global-font;
  position: relative;
  height: 181px;
  background: $color-white;
  border-radius: 6px;
  padding: 20px 20px;

  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    color: $color-denim;
    margin-bottom: 16px;
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    border-radius: 4px;
    background: rgba($color-denim, 0.15);
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    color: $color-denim;
    transition: .3s linear;
  }

  &__text {
    margin-left: 7px;
  }

  &-balance {
    padding-top: 20px;
    display: grid;
    grid-row-gap: 13px;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 130.4%;

    &__title {
      font-weight: 600;
      color: $color-denim;
    }

    &__flex {
      color: $color-japanese-laurel;
    }

    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/UserCard/UserEarned/UserEarned.vue